
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import Message from '@/components/message.vue';
  import Dialog from '@/components/dialog.vue';
  import {
    productBuyerproductBuyerPageInit,
    productBuyerproductBuyerDelete,
    productBuyerproductBuyerSave
  } from "@/api/supplier"
  @Component({  
    name: '',
    components: {
      PageFooter,
			'slz-message': Message,
      'slz-dialog': Dialog,
    }
  })

  export default class ProductList extends Vue {
    private keywords = ''
    private tablelist:any = []
    private tableloading = false
		private pageNo = 1;
		private pageSize = 10;
		private total = 0;
    private rowmsg:any = {}
    private delShow = false
    private editShow = false

    private mounted () {
      this.gettablelist()
    }

    private async confirmEdit(){
      if(!this.rowmsg.BuyerName){
        this.$message.error('请输入人员名称')
        return
      }
      try{
        this.tableloading = true
        let res:any = await productBuyerproductBuyerSave({...this.rowmsg})
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.editShow = false
          this.gettablelist()
        }
      }finally{
        this.tableloading = false
      }
    }
    private async confirmdel(){
      try{
        this.tableloading = true
        let res:any = await productBuyerproductBuyerDelete({
          Id:this.rowmsg.Id
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.delShow = false
          this.gettablelist()
        }
      }finally{
        this.tableloading = false
      }
    }
    private todel(row){
      this.rowmsg = row
      this.delShow = true
    }
    private tocreate(row){
      if(row.Id){
        this.rowmsg = JSON.parse(JSON.stringify(row))
      }else{
        this.rowmsg = {
          Id:0,
          BuyerName:'',
        }
      }
      this.editShow = true
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private clearSearch(){
      this.keywords = ''
      this.doSearch()
    }
    private changeCurrent(e){
      this.pageNo = e
      this.gettablelist()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let res:any = await productBuyerproductBuyerPageInit({
          Keywords:this.keywords,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        })
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
  }
